import React from "react";
import EditInfoContent from "../components/Admins/EditInfoContent";
import "./EditInfo.css";

const EditInfo = () => {
  return (
    <div className="edit-info-page">
      <main className="edit-info-main">
        <nav className="edit-tabs" aria-label="Profile Tabs">
          <button type="button" className="edit-tab active">
            Profile
          </button>
          <button type="button" className="edit-tab">
            Login History
          </button>
        </nav>

        <EditInfoContent />
      </main>
    </div>
  );
};

export default EditInfo;
